import PropTypes from 'prop-types';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';

import { ToolBar, ToolBarGroup } from 'src/legacy/components/ToolBar/ToolBar.jsx';
import { ToolBarButtonItem } from 'src/legacy/components/ToolBar/ToolBarButtonItem.jsx';
import ResponsiveHelper from "src/legacy/services/responsive.helper"

import { Row, Col, Image } from 'react-bootstrap';
import Truncate from 'src/components/truncate';



import ContactShareContainer from './../shares'
import userRoleService from "src/services/userRoles.service"

import cx from 'classnames';
import styles from './styles.module.scss';
import PlaceholderEmptyMessage from 'src/legacy/components/PlaceholderEmptyMessage';
import EmptyMessage from 'src/legacy/images/emptyMessage.svg'
import DeleteContactContainer from '../DeleteContactContainer';
import { localizedStrings } from 'src/localization/index.jsx';
import Tooltip from 'src/components/tooltip';

import _ from 'lodash';
import ComposeDialog from 'src/components/compose/components/dialog';

class ContactDetailsView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props);

    this.state = {
      currentPage: this.props.currentPage,
      showShareView: false,
      showDeleteConfirmation: false,
    }

    this._handleUpdateClicked = this._handleUpdateClicked.bind(this);
    this.loadMoreShares = this.loadMoreShares.bind(this);
    this._handleEmptyMsgActionClick = this._handleEmptyMsgActionClick.bind(this);
    this._handleDeleteClick = this._handleDeleteClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);
    this.getSource = this.getSource.bind(this);

    // localized contents
    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.localizedLoading = this.localizedCommons.loading;
    this.localizedCommonsActions = this.localizedCommons.actions;
    this.localizedContacts = this.localizedCommons.sliders.contacts;
  }

  loadMoreShares(page) {
    if (!this.props.contact) {
      return;
    }

    if (this.props.loading) {
      return;
    }

    this.props.fetchContactShareAnanlytics(this.props.contact.id, page);
  }

  componentDidMount() {

    if (this.props.id) {
      this.props.viewContact(this.props.id);
    }

    if (this.props.contact) {
      this.props.fetchContactShareAnanlytics(this.props.contact.id, 0)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.id != nextProps.id) {
      this.props.viewContact(nextProps.id);
    }

    var current = this.props.contact;
    var next = nextProps.contact;

    var changed = true;
    if (current && next) {
      changed = current.id != next.id;
    }

    if (changed && next) {
      this.props.fetchContactShareAnanlytics(next.id, 0);
    }
  }

  _handleUpdateClicked() {
    if (this.props.onUpdateClicked) {
      this.props.onUpdateClicked();
    }
  }

  _handleDeleteClick() {
    this.setState({
      showDeleteConfirmation: true
    })
  }

  _handleCancelClick(){
    this.setState({
      showDeleteConfirmation: false
    })
  }

  renderName() {
    return `${this.props.contact.firstName || ''} ${this.props.contact.lastName || ''}`
  }


  _handleEmptyMsgActionClick() {
    this.setState({
      showShareView: true
    })
  }

  _handleFetchSection(share, section) {
    return this.props.fetchShareSection(this.props.contact.id, share, section);
  }

  render() {
    if(!this.props.contact && this.props.loadingContact) {
      return null;
    }

    if (!this.props.contact && !this.props.loadingContact) {
      return (
      <div>
        <PlaceholderEmptyMessage
        title={this.localizedContacts.no_access.title}
        message={this.localizedContacts.no_access.message}
        image={EmptyMessage}
        className={cx(styles.noAccess)}
        visible={true}
        />
      </div>
      )
    }

    const id = _.get(this.props.contact, 'id');
    const online = _.get(this.props, `smallTalkPresence['${id}']`);

    return (
      <div className={cx(styles.list)}>
        {this.state.showDeleteConfirmation && 
          <DeleteContactContainer
            contactList={this.props.contactList ? this.props.contactList : ""}
            onDeletion={
              () => {
                this.setState({
                  showDeleteConfirmation: false
                })
                this.props.onClose();
              }
            }
            onCancel={
              () => {
                this.setState({
                  showDeleteConfirmation: false
                })
              }
            }
          />
        }
        {!this.state.showDeleteConfirmation && 
        <div className={styles.inner} ref={(element) => {
          this.scrollContainer = element;
        }}>
          {userRoleService.canCreateContact() && <ToolBar className={cx(styles.toolbar, { [styles.trial]: this.props.trial })}>
            <ToolBarGroup direction="left">
              <ToolBarButtonItem className={cx(styles.action, {[styles.inactiveToolItem] : this.props.sliderView && this.props.contactFormView })} width="auto" height="auto" onClick={this._handleUpdateClicked}>
                <i className="paperflite-edit" />{this.localizedContacts.actions.update_contact}
              </ToolBarButtonItem>
              {this.props.canDelete && <ToolBarButtonItem className={cx(styles.action, {[styles.inactiveToolItem] : this.props.contactFormView })} width="auto" height="auto" onClick={this._handleDeleteClick}>
                <i className="fa-regular fa-trash-can" />{this.localizedContacts.actions.delete_contact}
              </ToolBarButtonItem>
              }
            </ToolBarGroup>
          </ToolBar>}
            <Row className={cx(styles.contactDetails,{[styles.sliderView]:this.props.sliderView,[styles.hideContactDetail]: this.props.contactFormView})}>
              <Col xl={12} lg={12} md={12} className={styles.contactHeader}>
                  <div className={styles.left}>
                    {online &&
                      <div className={styles.active}></div>
                    }

                    {!this.props.contact.icon &&
                      <div className={styles.contactAvatar}>
                      <i className="paperflite-user-settings" />
                      </div>
                    }

                    {this.props.contact.icon &&
                      <Image className={styles.contactIcon} src={this.props.contact.icon.thumbnail} circle />
                    } 
                  </div>
                    <div className={styles.contactName}>
                    <Tooltip content={this.renderName().length > 40 ? this.renderName() : ""}>
                      <span>
                      <Truncate width={200} lines={1}>
                      {this.renderName()}
                      </Truncate>
                      </span>
                    </Tooltip>
                      {this.props.contact.doNotDisturb && 
                        <span className={cx(styles.source, styles.dnd)}>{this.localizedCommons.dnd}</span>
                      }
                      <div className={styles.contactMeta}>
                        <div className={styles.emailField}>
                          <span className={styles.email}><div dangerouslySetInnerHTML={{ __html: this.props.contact.email }}></div> </span>
                        </div>
                        <div className={styles.contactCompany}>
                          <Truncate width={100}>{this.props.contact.company}</Truncate>
                        </div>
                        { this.props.contact.title &&
                          <div className={styles.contactTitle}>
                            <Truncate  className={styles.company} lines={1} width={150}>{_.get(this.props,"contact.title","")}</Truncate>
                          </div>
                        }
                      </div>
                      <div className={styles.contactSources}>
                      {
                        this._renderSources()
                      }
                      </div>
                    </div> 
              </Col>
              <Col md={12} xl={12} lg={12}>
              <div className={styles.phoneField}>
                      {this.props.contact.workPhone &&
                        <div className={styles.workPhone}>
                          <div className={styles.label}>{this.localizedContacts.update_contact.work_phone}</div>
                            <span>
                          <Truncate lines={2} width={250} className={styles.value}>
                          {_.get(this.props,"contact.workPhone","")}
                            </Truncate>
                            </span>
                        </div>
                      }

                      {_.get(this.props,"contact.mobilePhone","") &&
                        <div className={styles.mobilePhone}>
                          <div className={styles.label}>{this.localizedContacts.update_contact.mobile_phone}</div>
                            <span>
                          <Truncate lines={2} width={250} className={styles.value}>
                            {_.get(this.prop,"contact.mobilePhone","")}
                          </Truncate>
                            </span>
                        </div>
                      }
                    </div>
              </Col>
            </Row>
            <div className={cx(styles.activityTitle, { [styles.hideHeading]: !this.props.loadingShares && this.props.shares.length == 0, [styles.hideContactDetail]: this.props.contactFormView })}>
              {this.localizedContacts.conversation_activity}
            </div>
            
            {!this.props.contactFormView && this._renderShares()}

            {!this.props.contactFormView && this.props.loadingShares &&
              <div className={styles.loading}>{this.localizedContacts.loading.shares} ... </div>
            }

            {this.props.backdrop &&
              <div className={styles.overlay}></div>
            }

            <ComposeDialog
              show={this.state.showShareView}
              dialog={true}
              onFinish={() => {
                this.setState({
                  showShareView: false,
                });
              }}
              onCancel={() => {
                this.setState({
                  showShreView: false,
                });
              }}
            />

        </div>
        }
      </div>
    );
  }

  getSource(source) {
    switch(source) {
      case 'quicksend':
        return this.localizedKeywords.quicksend;
      
      case 'generate_link':
        return this.localizedKeywords.generate_link;
      
      case 'lead':
        return this.localizedCommons.lead;
      
      case 'reshare':
        return this.localizedCommons.reshare;
      
      default:
        return source;
    }
  }

  _renderSources() {
    let sources = Array();

    if (!this.props.contact.sources)
      return;

    this.props.contact.sources.map((source, index) => {
      const contactSource = this.getSource(source);
      sources.push(
        <span key={index} className={styles.source}>{contactSource}</span>
      );
    });
    return sources;
  }

  _renderShares() {
    if (!this.props.loadingShares && this.props.shares.length == 0) {
      return this._renderEmptyMessage();
    }

    var shares = this.props.shares.map((share) => {
      return (
        <ContactShareContainer
          key={share.id}
          id={share.id}
          contact={this.props.contact.id}
          fetchAssetAnalytics={this.props.fetchAssetAnalytics.bind(this)}
          fetchShareSection={this._handleFetchSection.bind(this)}
        />
      );
    });

    return (
      <InfiniteScroll
        pageStart={0}
        initialLoad={false}
        hasMore={this.props.currentPage < this.props.totalPages}
        loadMore={(page) => { this.loadMoreShares(page) }}
        useWindow={false}
        threshold={250}
      >
        {shares}
      </InfiniteScroll>
    );
  }

  _renderEmptyMessage() {
    return (
      <PlaceholderEmptyMessage
        title={this.localizedContacts.empty_message.title}
        message={localizedStrings.formatString(this.localizedContacts.empty_message.message, { firstName: this.props.contact.firstName })}
        image={EmptyMessage}
        className={styles.emptyMessage}
        buttonText={this.localizedContacts.empty_message.action_button}
        onClick={this._handleEmptyMsgActionClick}
        visible={true}
      />
    );
  }

}

ContactDetailsView.contextTypes = {
  store: PropTypes.object,
  router: PropTypes.object
}

export default ContactDetailsView;